<template>
    <div class="space-y-2">
        <template v-if="hasSubSchemas">
            <SchemaCollapseItem v-for="(schemaItem, index) in schema" 
                               :key="index" 
                               :schema="schemaItem" />
        </template>
        <template v-else>
            <div class="border border-echoes-border-light rounded-lg bg-echoes-background-gray shadow-sm">
                <div class="overflow-x-auto custom-scrollbar-x">
                    <div class="max-h-[400px] overflow-y-auto custom-scrollbar-y">
                        <table class="w-full border-collapse text-sm">
                            <thead class="bg-echoes-background-gray sticky top-0 z-10">
                                <tr class="border-b border-echoes-border-light">
                                    <th class="px-6 py-3 text-left text-xs font-medium text-white/80 uppercase tracking-wider">
                                        Column name
                                    </th>
                                        <th class="px-6 py-3 text-left text-xs font-medium text-white/80 uppercase tracking-wider">
                                        Data type
                                    </th>
                                    <th class="px-6 py-3 text-left text-xs font-medium text-white/80 uppercase tracking-wider">
                                        Description
                                    </th>
                                </tr>
                            </thead>
                            <tbody class="bg-echoes-background-gray divide-y divide-echoes-border-light">
                                <tr v-for="(item, index) in schema" :key="index"
                                    class="hover:bg-echoes-background-black/50 transition-colors duration-200">
                                    <td class="px-6 py-3 text-sm font-medium text-white max-w-[200px] truncate">
                                        {{ item?.name }}
                                    </td>
                                    <td class="px-6 py-2.5 whitespace-nowrap">
                                        <span class="px-2 py-0.5 text-xs font-medium rounded-full bg-echoes-background-black/30 text-echoes-primary">
                                            {{ item?.type }}
                                        </span>
                                    </td>
                                    <td class="px-6 py-2.5 text-sm text-white/80">
                                        <div class="line-clamp-2">{{ item?.description || '-' }}</div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script setup>
import { defineProps, computed } from 'vue';
import SchemaCollapseItem from '@/components/SchemaCollapseItem.vue';

const props = defineProps({
    schema: {
        type: Array,
        required: true
    }
});

const schema = computed(() => {
    return Array.isArray(props.schema) && props.schema.length > 0 ? props.schema.map(item => ({
        name: item.column_name || item.title || item.column_title || item.name || '',
        type: item.type || item.data_type || '',
        description: item.description || ''
    })) : props.schema;
});

const hasSubSchemas = computed(() => {
    if (Array.isArray(schema.value)) {
        return schema.value?.some(item => item && Array.isArray(item));
    }
    return false;
});
</script>
